/** Cache 24h — flags sidebar (ESN, legacy billing) changent rarement */
export const TEAM_SIDEBAR_CONTEXT_CACHE_MS = 1000 * 60 * 60 * 24

export const teamSidebarContextKeys = {
  all: ['team', 'context'] as const,
  detail: (teamId: string | null | undefined) =>
    [...teamSidebarContextKeys.all, teamId] as const,
}
